var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h1", { staticClass: "no-print", class: _vm.$style.pageTitle }, [
        _vm._v(_vm._s(_vm.pageTitle))
      ]),
      _c(
        "div",
        { staticClass: "row", class: { "print-tab": _vm.isPrintTab } },
        [
          _c("div", { staticClass: "col-lg-12" }, [
            _c("div", { staticClass: "card" }, [
              _c(
                "div",
                {
                  staticClass: "card-header no-print",
                  staticStyle: {
                    padding: "8px 0 0",
                    "box-shadow": "0px 3px 2px #00000029"
                  }
                },
                [
                  _c(
                    "a-tabs",
                    {
                      class: _vm.$style.navBar,
                      attrs: { activeKey: _vm.tabIndex },
                      on: { tabClick: _vm.tabClick }
                    },
                    [
                      _c("a-tab-pane", { key: "1" }, [
                        _c(
                          "span",
                          { attrs: { slot: "tab" }, slot: "tab" },
                          [
                            _c("a-icon", { attrs: { type: "car" } }),
                            _vm._v("乗車前\n              ")
                          ],
                          1
                        )
                      ]),
                      _c("a-tab-pane", { key: "2" }, [
                        _c(
                          "span",
                          { attrs: { slot: "tab" }, slot: "tab" },
                          [
                            _c("a-icon", { attrs: { type: "car" } }),
                            _vm._v("乗車後\n              ")
                          ],
                          1
                        )
                      ]),
                      _c("a-tab-pane", { key: "3" }, [
                        _c(
                          "span",
                          { attrs: { slot: "tab" }, slot: "tab" },
                          [
                            _c("a-icon", { attrs: { type: "printer" } }),
                            _vm._v("印刷\n              ")
                          ],
                          1
                        )
                      ])
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "card-body" },
                [
                  _c(
                    "a-form",
                    {
                      staticClass: "no-print",
                      staticStyle: { "margin-bottom": "20px" },
                      attrs: { layout: "inline" }
                    },
                    [
                      _vm._v("\n            対象支店：\n            "),
                      _c(
                        "a-select",
                        {
                          staticStyle: { width: "30%", "margin-right": "20px" },
                          attrs: {
                            "show-search": "",
                            value: _vm.branchId,
                            "filter-option": _vm.filterOption
                          },
                          on: { change: _vm.targetBranchChange }
                        },
                        _vm._l(_vm.branches, function(item) {
                          return _c(
                            "a-select-option",
                            { key: item.id, attrs: { value: item.id } },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(item.name) +
                                  "\n              "
                              )
                            ]
                          )
                        }),
                        1
                      ),
                      _vm._v("\n            対象日：\n            "),
                      _c(
                        "a-button",
                        {
                          staticStyle: { "margin-right": "3px" },
                          on: {
                            click: function($event) {
                              return _vm.yesterday()
                            }
                          }
                        },
                        [_vm._v("前日")]
                      ),
                      _c(
                        "a-button",
                        {
                          staticStyle: { "margin-right": "3px" },
                          on: {
                            click: function($event) {
                              return _vm.today()
                            }
                          }
                        },
                        [_vm._v("今日")]
                      ),
                      _c(
                        "a-button",
                        {
                          staticStyle: { "margin-right": "7px" },
                          on: {
                            click: function($event) {
                              return _vm.tomorrow()
                            }
                          }
                        },
                        [_vm._v("翌日")]
                      ),
                      _c(
                        "a-config-provider",
                        { attrs: { locale: _vm.locale } },
                        [
                          _c("a-date-picker", {
                            attrs: { placeholder: "対象日" },
                            model: {
                              value: _vm.targetDate,
                              callback: function($$v) {
                                _vm.targetDate = $$v
                              },
                              expression: "targetDate"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "a-button",
                        {
                          class: _vm.$style.filledBtn,
                          staticStyle: { "margin-left": "10px" },
                          attrs: { type: "primary" },
                          on: { click: _vm.refreshList }
                        },
                        [_vm._v("取得")]
                      ),
                      _vm.isPrintTab
                        ? _c(
                            "a-button",
                            {
                              class: _vm.$style.filledBtn,
                              staticStyle: {
                                "margin-left": "10px",
                                "margin-right": "20px"
                              },
                              attrs: { type: "primary" },
                              on: { click: _vm.print }
                            },
                            [_vm._v("印刷")]
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm.isPrintTab
                    ? _c("p", { staticClass: "no-print text-right" }, [
                        _vm._v(
                          "※印刷時に点呼が全て表示されない場合は、印刷の設定を横向きにして試してみてください。"
                        )
                      ])
                    : _vm._e(),
                  _vm.isPrintTab
                    ? _c(
                        "div",
                        {
                          staticClass: "no-print text-right",
                          staticStyle: { "margin-top": "10px" }
                        },
                        [
                          _c(
                            "span",
                            { staticStyle: { "margin-right": "10px" } },
                            [_vm._v("運行情報を表示")]
                          ),
                          _c("a-switch", {
                            model: {
                              value: _vm.showDriveInfo,
                              callback: function($$v) {
                                _vm.showDriveInfo = $$v
                              },
                              expression: "showDriveInfo"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.loading
                    ? _c(
                        "div",
                        {
                          staticClass: "text-center",
                          staticStyle: {
                            "margin-top": "50px",
                            "margin-bottom": "50px"
                          }
                        },
                        [_c("a-spin", { attrs: { tip: "Loading..." } })],
                        1
                      )
                    : _vm._e(),
                  !_vm.loading
                    ? _c(
                        "div",
                        [
                          _c("h3", [_vm._v(_vm._s(_vm.subTitle))]),
                          !_vm.isPrintTab
                            ? _c(
                                "div",
                                {
                                  staticClass: "clearfix",
                                  class: _vm.$style.tableTopButtons
                                },
                                [
                                  _c(
                                    "p",
                                    [
                                      _c(
                                        "a-button",
                                        {
                                          class: _vm.$style.filledBtn,
                                          attrs: {
                                            type: "primary",
                                            disabled:
                                              _vm.isRollCallExeButtonDisabled
                                          },
                                          on: { click: _vm.rollCallExecute }
                                        },
                                        [
                                          _vm._v(
                                            "\n                  確認済みにする\n                "
                                          )
                                        ]
                                      ),
                                      _c(
                                        "router-link",
                                        {
                                          attrs: {
                                            to: {
                                              name: "alcoholCheckUnconfirmed",
                                              params: {
                                                tabIndex: _vm.tabIndex,
                                                branchId: _vm.branchId
                                              }
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "a-button",
                                            {
                                              class: _vm.$style.filledBtn,
                                              staticStyle: {
                                                "margin-left": "7px"
                                              },
                                              attrs: { type: "primary" }
                                            },
                                            [
                                              _vm._v(
                                                "\n                    未確認一覧\n                  "
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "p",
                                    [
                                      _c(
                                        "a-button",
                                        {
                                          class: _vm.$style.filledBtn,
                                          attrs: { type: "primary" },
                                          on: { click: _vm.createAlcoholCheck }
                                        },
                                        [_vm._v("作成")]
                                      )
                                    ],
                                    1
                                  )
                                ]
                              )
                            : _vm._e(),
                          _c(
                            "a-table",
                            {
                              style: {
                                "min-height": _vm.minHeight + " !important"
                              },
                              attrs: {
                                columns: _vm.columns,
                                "data-source": _vm.alcoholCheckDataList,
                                pagination: false,
                                bordered: _vm.isPrintTab,
                                rowKey: "id",
                                rowClassName: function(r, i) {
                                  return i % 2 === 0 && r.manual_flag === 1
                                    ? _vm.$style.manual_row +
                                        " " +
                                        _vm.$style.stripe
                                    : i % 2 === 0
                                    ? _vm.$style.stripe
                                    : r.manual_flag === 1
                                    ? _vm.$style.manual_row
                                    : ""
                                }
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "confirmed",
                                    fn: function(id, record) {
                                      return _c("span", {}, [
                                        !record.confirmed
                                          ? _c(
                                              "div",
                                              [
                                                _c("a-checkbox", {
                                                  attrs: {
                                                    checked: _vm.isConfRowChecked(
                                                      record.id
                                                    )
                                                  },
                                                  on: {
                                                    change: function($event) {
                                                      return _vm.onChangeConfirmedRow(
                                                        $event,
                                                        record.id
                                                      )
                                                    }
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        record.confirmed
                                          ? _c("span", [_vm._v("確認済")])
                                          : _vm._e()
                                      ])
                                    }
                                  },
                                  {
                                    key: "branch_name",
                                    fn: function(id, record) {
                                      return _c("span", {}, [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(record.branch_name) +
                                            "\n              "
                                        )
                                      ])
                                    }
                                  },
                                  {
                                    key: "driver",
                                    fn: function(id, record) {
                                      return _c("span", {}, [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(record.user_name)
                                        ),
                                        _vm.isPrintTab ? _c("br") : _vm._e(),
                                        _vm._v(
                                          " (" +
                                            _vm._s(record.vehicle_name) +
                                            ")\n              "
                                        )
                                      ])
                                    }
                                  },
                                  {
                                    key: "item_allow_ride",
                                    fn: function(id, record) {
                                      return _c("span", {}, [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm.itemAllowRide[
                                                record.item_allow_ride
                                              ]
                                            ) +
                                            "\n              "
                                        )
                                      ])
                                    }
                                  },
                                  {
                                    key: "call_datetime",
                                    fn: function(id, record) {
                                      return _c("span", {}, [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm.showDateTime(
                                                record.call_datetime
                                              )
                                            ) +
                                            "\n              "
                                        )
                                      ])
                                    }
                                  },
                                  {
                                    key: "item_alcohol_detector",
                                    fn: function(id, record) {
                                      return _c("span", {}, [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm.itemAlcoholDetector[
                                                record.item_alcohol_detector
                                              ]
                                            ) +
                                            "\n              "
                                        )
                                      ])
                                    }
                                  },
                                  {
                                    key: "item_drinking",
                                    fn: function(id, record) {
                                      return _c("span", {}, [
                                        _c(
                                          "span",
                                          {
                                            class: [
                                              record.alcohol_measurement_result >=
                                              _vm.alcoholThreshold
                                                ? _vm.$style.colorRed
                                                : ""
                                            ]
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.itemDrinking[
                                                  record.item_drinking
                                                ]
                                              )
                                            )
                                          ]
                                        )
                                      ])
                                    }
                                  },
                                  {
                                    key: "alcohol_measurement_result",
                                    fn: function(id, record) {
                                      return _c("span", {}, [
                                        _c(
                                          "span",
                                          {
                                            class: [
                                              record.alcohol_measurement_result >=
                                              _vm.alcoholThreshold
                                                ? _vm.$style.colorRed
                                                : ""
                                            ]
                                          },
                                          [
                                            record.detector === 1
                                              ? _c("i", {
                                                  staticClass:
                                                    "fa fa-bluetooth",
                                                  staticStyle: {
                                                    color: "#146DAD",
                                                    "margin-right": "3px"
                                                  }
                                                })
                                              : _vm._e(),
                                            _vm._v(
                                              _vm._s(
                                                record.alcohol_measurement_result
                                              )
                                            )
                                          ]
                                        )
                                      ])
                                    }
                                  },
                                  {
                                    key: "item_roll_call_type",
                                    fn: function(id, record) {
                                      return _c("span", {}, [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm.itemRollCallType[
                                                record.item_roll_call_type
                                              ]
                                            ) +
                                            "\n              "
                                        )
                                      ])
                                    }
                                  },
                                  {
                                    key: "roll_call_executer_id",
                                    fn: function(id, record) {
                                      return _c("span", {}, [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(record.executer_name) +
                                            "\n              "
                                        )
                                      ])
                                    }
                                  },
                                  {
                                    key: "update",
                                    fn: function(id, record) {
                                      return _c(
                                        "span",
                                        {},
                                        [
                                          _vm.myRole <= 2 ||
                                          _vm.myRollCallAble === 1
                                            ? _c(
                                                "a-button",
                                                {
                                                  staticStyle: {
                                                    padding: "0 10px",
                                                    "margin-right": "4px"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.updateAlcoholCheck(
                                                        record.id
                                                      )
                                                    }
                                                  }
                                                },
                                                [_vm._v("編集")]
                                              )
                                            : _vm._e(),
                                          _c(
                                            "a-button",
                                            {
                                              staticStyle: { padding: "0 6px" },
                                              on: {
                                                click: function($event) {
                                                  return _vm.updateAlcoholCheckSelf(
                                                    record.id
                                                  )
                                                }
                                              }
                                            },
                                            [_vm._v("自由項目編集")]
                                          )
                                        ],
                                        1
                                      )
                                    }
                                  },
                                  {
                                    key: "call_datetime_end",
                                    fn: function(id, record) {
                                      return _c("span", {}, [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm.showDateTime(
                                                record.call_datetime_end
                                              )
                                            ) +
                                            "\n              "
                                        )
                                      ])
                                    }
                                  },
                                  {
                                    key: "item_alcohol_detector_end",
                                    fn: function(id, record) {
                                      return _c("span", {}, [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm.itemAlcoholDetector[
                                                record.item_alcohol_detector_end
                                              ]
                                            ) +
                                            "\n              "
                                        )
                                      ])
                                    }
                                  },
                                  {
                                    key: "item_drinking_end",
                                    fn: function(id, record) {
                                      return _c("span", {}, [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm.itemDrinking[
                                                record.item_drinking_end
                                              ]
                                            ) +
                                            "\n              "
                                        )
                                      ])
                                    }
                                  },
                                  {
                                    key: "item_roll_call_type_end",
                                    fn: function(id, record) {
                                      return _c("span", {}, [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm.itemRollCallType[
                                                record.item_roll_call_type_end
                                              ]
                                            ) +
                                            "\n              "
                                        )
                                      ])
                                    }
                                  },
                                  {
                                    key: "roll_call_executer_id_end",
                                    fn: function(id, record) {
                                      return _c("span", {}, [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(record.executer_name_end) +
                                            "\n              "
                                        )
                                      ])
                                    }
                                  },
                                  {
                                    key: "drive_total_distance",
                                    fn: function(id, record) {
                                      return _c(
                                        "span",
                                        {},
                                        [
                                          record.drive_total_distance &&
                                          record.user_id &&
                                          record.date
                                            ? _c(
                                                "router-link",
                                                {
                                                  staticStyle: {
                                                    "text-decoration":
                                                      "underline"
                                                  },
                                                  attrs: {
                                                    to:
                                                      "/drive_data/user/" +
                                                      record.user_id +
                                                      "/" +
                                                      record.date
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                  " +
                                                      _vm._s(
                                                        _vm.formatDistance(
                                                          record.drive_total_distance
                                                        )
                                                      ) +
                                                      "\n                "
                                                  )
                                                ]
                                              )
                                            : _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.formatDistance(
                                                      record.drive_total_distance
                                                    )
                                                  )
                                                )
                                              ])
                                        ],
                                        1
                                      )
                                    }
                                  },
                                  {
                                    key: "drive_time_range",
                                    fn: function(id, record) {
                                      return _c("span", {}, [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm.formatDriveTimeRange(
                                                record.drive_min_time_start,
                                                record.drive_max_time_end
                                              )
                                            ) +
                                            "\n              "
                                        )
                                      ])
                                    }
                                  }
                                ],
                                null,
                                false,
                                3195576960
                              )
                            },
                            [
                              _c(
                                "span",
                                {
                                  attrs: { slot: "confirmedTitle" },
                                  slot: "confirmedTitle"
                                },
                                [
                                  _c(
                                    "a-checkbox",
                                    {
                                      attrs: {
                                        indeterminate: _vm.isConfIndeterminate,
                                        checked: _vm.isConfAllChecked
                                      },
                                      on: { change: _vm.onChangeConfirmedAll }
                                    },
                                    [
                                      _vm._v(
                                        "\n                  確認\n                "
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ]
                          ),
                          !_vm.isPrintTab
                            ? _c(
                                "p",
                                {
                                  staticClass: "text-right",
                                  staticStyle: { "margin-top": "20px" }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      class: _vm.$style.manual_row,
                                      staticStyle: { padding: "3px" }
                                    },
                                    [
                                      _vm._v(
                                        "この色の行は手動で作成したものです。"
                                      )
                                    ]
                                  )
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ]),
            _vm.isPrintTab
              ? _c("div", { staticClass: "card no-print" }, [
                  _vm._m(0),
                  _c(
                    "div",
                    { staticClass: "card-body no-print" },
                    [
                      _c(
                        "a-form",
                        {
                          staticStyle: { "margin-bottom": "20px" },
                          attrs: { layout: "inline" }
                        },
                        [
                          _c(
                            "p",
                            [
                              _vm._v(
                                "\n              対象支店：\n              "
                              ),
                              _c(
                                "a-select",
                                {
                                  staticStyle: {
                                    width: "30%",
                                    "margin-right": "20px"
                                  },
                                  attrs: {
                                    "show-search": "",
                                    value: _vm.branchId,
                                    "filter-option": _vm.filterOption
                                  },
                                  on: { change: _vm.targetBranchChange }
                                },
                                _vm._l(_vm.branches, function(item) {
                                  return _c(
                                    "a-select-option",
                                    { key: item.id, attrs: { value: item.id } },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(item.name) +
                                          "\n                "
                                      )
                                    ]
                                  )
                                }),
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "p",
                            [
                              _vm._v("\n              対象期間: "),
                              _c("a-date-picker", {
                                attrs: { value: _vm.exportDateStart },
                                on: { change: _vm.changeExportDateStart }
                              }),
                              _vm._v(" 〜 "),
                              _c("a-date-picker", {
                                staticStyle: { "margin-right": "20px" },
                                attrs: { value: _vm.exportDateEnd },
                                on: { change: _vm.changeExportDateEnd }
                              })
                            ],
                            1
                          ),
                          _c(
                            "p",
                            [
                              _vm._v(
                                "\n              運行情報:\n              "
                              ),
                              _c(
                                "a-radio-group",
                                {
                                  staticStyle: { "margin-left": "10px" },
                                  model: {
                                    value: _vm.includeDriveInfoInCsv,
                                    callback: function($$v) {
                                      _vm.includeDriveInfoInCsv = $$v
                                    },
                                    expression: "includeDriveInfoInCsv"
                                  }
                                },
                                [
                                  _c("a-radio", { attrs: { value: true } }, [
                                    _vm._v("含める")
                                  ]),
                                  _c("a-radio", { attrs: { value: false } }, [
                                    _vm._v("含めない")
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "a-button",
                            {
                              class: _vm.$style.filledBtn,
                              staticStyle: { "margin-left": "10px" },
                              attrs: {
                                type: "primary",
                                loading: _vm.exportLoading
                              },
                              on: { click: _vm.csvExport }
                            },
                            [_vm._v("出力")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ])
              : _vm._e()
          ])
        ]
      ),
      _c(
        "a-modal",
        {
          attrs: { title: _vm.modalText, visible: _vm.modalVisible },
          on: { cancel: _vm.handleCancelAlcoholCheckModal }
        },
        [
          _c(
            "div",
            [
              _c(
                "a-form-model",
                { attrs: { model: _vm.alcoholCheckForm } },
                [
                  _vm.myRole === 0
                    ? _c(
                        "a-form-model-item",
                        {
                          ref: "item_allow_ride",
                          attrs: { label: "乗車 前・後", prop: "type" }
                        },
                        [
                          _c(
                            "a-radio-group",
                            {
                              model: {
                                value: _vm.alcoholCheckForm.type,
                                callback: function($$v) {
                                  _vm.$set(_vm.alcoholCheckForm, "type", $$v)
                                },
                                expression: "alcoholCheckForm.type"
                              }
                            },
                            [
                              _c("a-radio", { attrs: { value: 0 } }, [
                                _vm._v("乗車前")
                              ]),
                              _c("a-radio", { attrs: { value: 1 } }, [
                                _vm._v("乗車後")
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.myRole === 0
                    ? _c(
                        "a-form-model-item",
                        {
                          ref: "callDate",
                          attrs: { label: "点呼日", prop: "onCallDate" }
                        },
                        [
                          _c("a-date-picker", {
                            model: {
                              value: _vm.onCallDate,
                              callback: function($$v) {
                                _vm.onCallDate = $$v
                              },
                              expression: "onCallDate"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.alcoholCheckCreate || _vm.myRole === 0
                    ? _c(
                        "a-form-model-item",
                        {
                          ref: "callDate",
                          attrs: { label: "点呼確認日", prop: "callDate" }
                        },
                        [
                          _c("a-date-picker", {
                            model: {
                              value: _vm.createCallDate,
                              callback: function($$v) {
                                _vm.createCallDate = $$v
                              },
                              expression: "createCallDate"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.alcoholCheckCreate || _vm.myRole === 0
                    ? _c(
                        "a-form-model-item",
                        {
                          ref: "callTime",
                          attrs: { label: "点呼確認時刻", prop: "callTime" }
                        },
                        [
                          _c("a-time-picker", {
                            model: {
                              value: _vm.createCallTime,
                              callback: function($$v) {
                                _vm.createCallTime = $$v
                              },
                              expression: "createCallTime"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.alcoholCheckCreate || _vm.myRole === 0
                    ? _c(
                        "a-form-model-item",
                        {
                          ref: "driver",
                          attrs: { label: "運転者", prop: "driver" }
                        },
                        [
                          _c(
                            "a-select",
                            {
                              attrs: {
                                "show-search": "",
                                value: _vm.alcoholCheckForm.user_id,
                                "filter-option": _vm.filterOption
                              },
                              on: { change: _vm.targetDriverChange }
                            },
                            [
                              _c(
                                "a-select-option",
                                { key: "0", attrs: { value: "0" } },
                                [_vm._v("\n              未選択\n            ")]
                              ),
                              _vm._l(_vm.drivers, function(item) {
                                return _c(
                                  "a-select-option",
                                  { key: item.id, attrs: { value: item.id } },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(item.name) +
                                        "\n            "
                                    )
                                  ]
                                )
                              })
                            ],
                            2
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.alcoholCheckCreate || _vm.myRole === 0
                    ? _c(
                        "a-form-model-item",
                        {
                          ref: "vehicle",
                          attrs: { label: "車両", prop: "vehicle" }
                        },
                        [
                          _c(
                            "a-select",
                            {
                              attrs: {
                                "show-search": "",
                                value: _vm.alcoholCheckForm.vehicle_id,
                                "filter-option": _vm.filterOption
                              },
                              on: { change: _vm.targetVehicleChange }
                            },
                            [
                              _c(
                                "a-select-option",
                                { key: "0", attrs: { value: "0" } },
                                [_vm._v("\n              未選択\n            ")]
                              ),
                              _vm._l(_vm.vehicles, function(item) {
                                return _c(
                                  "a-select-option",
                                  { key: item.id, attrs: { value: item.id } },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(item.branch_name) +
                                        ": " +
                                        _vm._s(item.name) +
                                        "\n            "
                                    )
                                  ]
                                )
                              })
                            ],
                            2
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.myRole === 0
                    ? _c(
                        "a-form-model-item",
                        {
                          ref: "roll_call_executer_id",
                          attrs: { prop: "roll_call_executer_id" }
                        },
                        [
                          _c(
                            "template",
                            { slot: "label" },
                            [
                              _vm._v("\n            点呼執行者\n            "),
                              _c(
                                "a-tag",
                                {
                                  staticStyle: {
                                    "margin-left": "4px",
                                    "font-size": "11px",
                                    "line-height": "18px",
                                    padding: "0 4px"
                                  },
                                  attrs: { color: "purple" }
                                },
                                [_vm._v("マスターのみ")]
                              )
                            ],
                            1
                          ),
                          _c(
                            "a-select",
                            {
                              staticStyle: {
                                width: "100%",
                                "margin-bottom": "6px"
                              },
                              attrs: {
                                "show-search": "",
                                value:
                                  _vm.alcoholCheckForm.roll_call_executer_id,
                                placeholder: "会社内のユーザーから選択",
                                "filter-option": _vm.filterOption,
                                "allow-clear": ""
                              },
                              on: {
                                change: function(val) {
                                  _vm.alcoholCheckForm.roll_call_executer_id = val
                                  _vm.executerName = ""
                                  _vm.executerNameError = ""
                                }
                              }
                            },
                            _vm._l(_vm.drivers, function(item) {
                              return _c(
                                "a-select-option",
                                { key: item.id, attrs: { value: item.id } },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(item.name) +
                                      "\n            "
                                  )
                                ]
                              )
                            }),
                            1
                          ),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "align-items": "center"
                              }
                            },
                            [
                              _c("a-input-number", {
                                staticStyle: { width: "140px" },
                                attrs: { min: 1, placeholder: "IDを直接入力" },
                                model: {
                                  value:
                                    _vm.alcoholCheckForm.roll_call_executer_id,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.alcoholCheckForm,
                                      "roll_call_executer_id",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "alcoholCheckForm.roll_call_executer_id"
                                }
                              }),
                              _c(
                                "a-button",
                                {
                                  staticStyle: { "margin-left": "8px" },
                                  attrs: { loading: _vm.executerNameLoading },
                                  on: { click: _vm.fetchExecuterName }
                                },
                                [_vm._v("執行者名を取得する")]
                              )
                            ],
                            1
                          ),
                          _vm.executerName
                            ? _c(
                                "div",
                                {
                                  staticStyle: {
                                    "margin-top": "4px",
                                    color: "#52c41a"
                                  }
                                },
                                [_vm._v(_vm._s(_vm.executerName))]
                              )
                            : _vm._e(),
                          _vm.executerNameError
                            ? _c(
                                "div",
                                {
                                  staticStyle: {
                                    "margin-top": "4px",
                                    color: "#f5222d"
                                  }
                                },
                                [_vm._v(_vm._s(_vm.executerNameError))]
                              )
                            : _vm._e()
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm.myRole === 0
                    ? _c(
                        "a-form-model-item",
                        { ref: "manual_flag", attrs: { prop: "manual_flag" } },
                        [
                          _c(
                            "template",
                            { slot: "label" },
                            [
                              _vm._v("\n            手動フラグ\n            "),
                              _c(
                                "a-tag",
                                {
                                  staticStyle: {
                                    "margin-left": "4px",
                                    "font-size": "11px",
                                    "line-height": "18px",
                                    padding: "0 4px"
                                  },
                                  attrs: { color: "purple" }
                                },
                                [_vm._v("マスターのみ")]
                              )
                            ],
                            1
                          ),
                          _c(
                            "a-radio-group",
                            {
                              model: {
                                value: _vm.alcoholCheckForm.manual_flag,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.alcoholCheckForm,
                                    "manual_flag",
                                    $$v
                                  )
                                },
                                expression: "alcoholCheckForm.manual_flag"
                              }
                            },
                            [
                              _c("a-radio", { attrs: { value: 1 } }, [
                                _vm._v("手動")
                              ]),
                              _c("a-radio", { attrs: { value: 0 } }, [
                                _vm._v("手動でない")
                              ])
                            ],
                            1
                          )
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm.myRole === 0
                    ? _c(
                        "a-form-model-item",
                        { ref: "confirmed", attrs: { prop: "confirmed" } },
                        [
                          _c(
                            "template",
                            { slot: "label" },
                            [
                              _vm._v("\n            確認状態\n            "),
                              _c(
                                "a-tag",
                                {
                                  staticStyle: {
                                    "margin-left": "4px",
                                    "font-size": "11px",
                                    "line-height": "18px",
                                    padding: "0 4px"
                                  },
                                  attrs: { color: "purple" }
                                },
                                [_vm._v("マスターのみ")]
                              ),
                              !_vm.alcoholCheckCreate &&
                              _vm.editingAgentFlag !== null
                                ? _c(
                                    "a-tag",
                                    {
                                      staticStyle: {
                                        "margin-left": "4px",
                                        "font-size": "11px",
                                        "line-height": "18px",
                                        padding: "0 4px"
                                      },
                                      attrs: {
                                        color:
                                          _vm.editingAgentFlag > 0
                                            ? "red"
                                            : "blue"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.editingAgentFlag > 0
                                            ? "点呼代行の点呼"
                                            : "点呼代行ではない"
                                        )
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ],
                            1
                          ),
                          _c(
                            "a-radio-group",
                            {
                              model: {
                                value: _vm.alcoholCheckForm.confirmed,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.alcoholCheckForm,
                                    "confirmed",
                                    $$v
                                  )
                                },
                                expression: "alcoholCheckForm.confirmed"
                              }
                            },
                            [
                              _c("a-radio", { attrs: { value: 1 } }, [
                                _vm._v("確認済み")
                              ]),
                              _c("a-radio", { attrs: { value: 0 } }, [
                                _vm._v("未確認")
                              ])
                            ],
                            1
                          )
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm.myRole === 0
                    ? _c(
                        "a-form-model-item",
                        { ref: "detector", attrs: { prop: "detector" } },
                        [
                          _c(
                            "template",
                            { slot: "label" },
                            [
                              _vm._v("\n            連動検知器\n            "),
                              _c(
                                "a-tag",
                                {
                                  staticStyle: {
                                    "margin-left": "4px",
                                    "font-size": "11px",
                                    "line-height": "18px",
                                    padding: "0 4px"
                                  },
                                  attrs: { color: "purple" }
                                },
                                [_vm._v("マスターのみ")]
                              )
                            ],
                            1
                          ),
                          _c(
                            "a-radio-group",
                            {
                              model: {
                                value: _vm.alcoholCheckForm.detector,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.alcoholCheckForm,
                                    "detector",
                                    $$v
                                  )
                                },
                                expression: "alcoholCheckForm.detector"
                              }
                            },
                            [
                              _c("a-radio", { attrs: { value: 0 } }, [
                                _vm._v("未使用")
                              ]),
                              _c("a-radio", { attrs: { value: 1 } }, [
                                _vm._v("連動検知器")
                              ]),
                              _c("a-radio", { attrs: { value: 2 } }, [
                                _vm._v("その他検知器")
                              ])
                            ],
                            1
                          )
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm.isStartTab
                    ? _c(
                        "a-form-model-item",
                        {
                          ref: "item_allow_ride",
                          attrs: { label: "乗車可否", prop: "item_allow_ride" }
                        },
                        [
                          _c(
                            "a-radio-group",
                            {
                              model: {
                                value: _vm.alcoholCheckForm.item_allow_ride,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.alcoholCheckForm,
                                    "item_allow_ride",
                                    $$v
                                  )
                                },
                                expression: "alcoholCheckForm.item_allow_ride"
                              }
                            },
                            [
                              _c("a-radio", { attrs: { value: 0 } }, [
                                _vm._v("未選択")
                              ]),
                              _c("a-radio", { attrs: { value: 1 } }, [
                                _vm._v("許可")
                              ]),
                              _c("a-radio", { attrs: { value: 2 } }, [
                                _vm._v("非許可")
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "a-form-model-item",
                    {
                      ref: "item_alcohol_detector",
                      attrs: {
                        label: "アルコール検知器の有無",
                        prop: "item_alcohol_detector"
                      }
                    },
                    [
                      _c(
                        "a-radio-group",
                        {
                          model: {
                            value: _vm.alcoholCheckForm.item_alcohol_detector,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.alcoholCheckForm,
                                "item_alcohol_detector",
                                $$v
                              )
                            },
                            expression: "alcoholCheckForm.item_alcohol_detector"
                          }
                        },
                        [
                          _c("a-radio", { attrs: { value: 0 } }, [
                            _vm._v("未選択")
                          ]),
                          _c("a-radio", { attrs: { value: 1 } }, [
                            _vm._v("有")
                          ]),
                          _c("a-radio", { attrs: { value: 2 } }, [_vm._v("無")])
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-form-model-item",
                    {
                      ref: "item_drinking",
                      attrs: { label: "酒気帯びの有無", prop: "item_drinking" }
                    },
                    [
                      _c(
                        "a-radio-group",
                        {
                          model: {
                            value: _vm.alcoholCheckForm.item_drinking,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.alcoholCheckForm,
                                "item_drinking",
                                $$v
                              )
                            },
                            expression: "alcoholCheckForm.item_drinking"
                          }
                        },
                        [
                          _c("a-radio", { attrs: { value: 0 } }, [
                            _vm._v("未選択")
                          ]),
                          _c("a-radio", { attrs: { value: 1 } }, [
                            _vm._v("有")
                          ]),
                          _c("a-radio", { attrs: { value: 2 } }, [_vm._v("無")])
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-form-model-item",
                    {
                      ref: "item_roll_call_type",
                      attrs: { label: "点呼方法", prop: "item_roll_call_type" }
                    },
                    [
                      _c(
                        "a-radio-group",
                        {
                          model: {
                            value: _vm.alcoholCheckForm.item_roll_call_type,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.alcoholCheckForm,
                                "item_roll_call_type",
                                $$v
                              )
                            },
                            expression: "alcoholCheckForm.item_roll_call_type"
                          }
                        },
                        [
                          _c("a-radio", { attrs: { value: 0 } }, [
                            _vm._v("未選択")
                          ]),
                          _c("a-radio", { attrs: { value: 1 } }, [
                            _vm._v("対面")
                          ]),
                          _c("a-radio", { attrs: { value: 2 } }, [
                            _vm._v("ビデオ通話")
                          ]),
                          _c("a-radio", { attrs: { value: 3 } }, [
                            _vm._v("電話")
                          ]),
                          _c("a-radio", { attrs: { value: 4 } }, [
                            _vm._v("その他")
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm.myRole === 0 ||
                  _vm.canUpdateAlcoholMeasurementResult === 1
                    ? _c(
                        "a-form-model-item",
                        {
                          ref: "alcohol_measurement_result",
                          attrs: {
                            label: "アルコール濃度",
                            prop: "alcohol_measurement_result"
                          }
                        },
                        [
                          _c("a-input-number", {
                            attrs: { min: 0, max: 100 },
                            model: {
                              value:
                                _vm.alcoholCheckForm.alcohol_measurement_result,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.alcoholCheckForm,
                                  "alcohol_measurement_result",
                                  $$v
                                )
                              },
                              expression:
                                "alcoholCheckForm.alcohol_measurement_result"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._l(_vm.freeItemDefList, function(item) {
                    return _c(
                      "div",
                      { key: item.id },
                      [
                        (_vm.isStartTab && item.show_timing !== 2) ||
                        (_vm.isEndTab && item.show_timing !== 1)
                          ? _c(
                              "a-form-model-item",
                              {
                                attrs: {
                                  label: item.name,
                                  rules: [
                                    {
                                      required: item.required_item === 1,
                                      message: "必須項目です。"
                                    }
                                  ]
                                }
                              },
                              [
                                item.choice
                                  ? _c(
                                      "div",
                                      _vm._l(item.choice.split("||"), function(
                                        choice
                                      ) {
                                        return _c(
                                          "a-button",
                                          {
                                            key: choice,
                                            on: {
                                              click: function($event) {
                                                return _vm.inputFreeItem(
                                                  item.id,
                                                  choice
                                                )
                                              }
                                            }
                                          },
                                          [_vm._v(_vm._s(choice))]
                                        )
                                      }),
                                      1
                                    )
                                  : _vm._e(),
                                _c("a-input", {
                                  model: {
                                    value:
                                      _vm.alcoholCheckForm.free_items[item.id],
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.alcoholCheckForm.free_items,
                                        item.id,
                                        $$v
                                      )
                                    },
                                    expression:
                                      "alcoholCheckForm.free_items[item.id]"
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  })
                ],
                2
              )
            ],
            1
          ),
          _c("template", { slot: "footer" }, [
            _c("div", { staticClass: "clearfix" }, [
              _c(
                "div",
                { staticClass: "float-right" },
                [
                  _c(
                    "a-button",
                    {
                      key: "back",
                      on: { click: _vm.handleCancelAlcoholCheckModal }
                    },
                    [_vm._v("\n            キャンセル\n          ")]
                  ),
                  _c(
                    "a-button",
                    {
                      key: "submit",
                      class: _vm.$style.filledBtn,
                      attrs: {
                        type: "primary",
                        loading: _vm.alcoholCheckConfirmLoading
                      },
                      on: { click: _vm.handleOkAlcoholCheck }
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.modalText) +
                          "\n          "
                      )
                    ]
                  )
                ],
                1
              ),
              _vm.isDeletable
                ? _c(
                    "div",
                    { staticClass: "float-left" },
                    [
                      _c(
                        "a-button",
                        {
                          class: _vm.$style.filledBtn,
                          staticStyle: {
                            "background-color": "#EF5350 !important"
                          },
                          attrs: { loading: _vm.alcoholCheckConfirmLoading },
                          on: { click: _vm.handleDeleteAlcoholCheck }
                        },
                        [_vm._v("\n            削除\n          ")]
                      )
                    ],
                    1
                  )
                : _vm._e()
            ])
          ])
        ],
        2
      ),
      _c(
        "a-modal",
        {
          attrs: { title: "自由項目編集", visible: _vm.modalVisibleSelf },
          on: { cancel: _vm.handleCancelAlcoholCheckSelfModal }
        },
        [
          _c(
            "div",
            [
              _c(
                "a-form-model",
                { attrs: { model: _vm.alcoholCheckForm } },
                _vm._l(_vm.freeItemDefList, function(item) {
                  return _c(
                    "div",
                    { key: item.id },
                    [
                      item.edit_self_flag &&
                      ((_vm.isStartTab && item.show_timing !== 2) ||
                        (_vm.isEndTab && item.show_timing !== 1))
                        ? _c(
                            "a-form-model-item",
                            { attrs: { label: item.name } },
                            [
                              item.choice
                                ? _c(
                                    "div",
                                    _vm._l(item.choice.split("||"), function(
                                      choice
                                    ) {
                                      return _c(
                                        "a-button",
                                        {
                                          key: choice,
                                          on: {
                                            click: function($event) {
                                              return _vm.inputFreeItem(
                                                item.id,
                                                choice
                                              )
                                            }
                                          }
                                        },
                                        [_vm._v(_vm._s(choice))]
                                      )
                                    }),
                                    1
                                  )
                                : _vm._e(),
                              _c("a-input", {
                                model: {
                                  value:
                                    _vm.alcoholCheckForm.free_items[item.id],
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.alcoholCheckForm.free_items,
                                      item.id,
                                      $$v
                                    )
                                  },
                                  expression:
                                    "alcoholCheckForm.free_items[item.id]"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                }),
                0
              )
            ],
            1
          ),
          _c("template", { slot: "footer" }, [
            _c("div", { staticClass: "clearfix" }, [
              _c(
                "div",
                { staticClass: "float-right" },
                [
                  _c(
                    "a-button",
                    {
                      key: "back",
                      on: { click: _vm.handleCancelAlcoholCheckSelfModal }
                    },
                    [_vm._v("\n            キャンセル\n          ")]
                  ),
                  _c(
                    "a-button",
                    {
                      key: "submit",
                      class: _vm.$style.filledBtn,
                      attrs: {
                        type: "primary",
                        loading: _vm.alcoholCheckConfirmLoading
                      },
                      on: { click: _vm.handleOkAlcoholCheckSelf }
                    },
                    [_vm._v("\n            更新\n          ")]
                  )
                ],
                1
              )
            ])
          ])
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "card-header",
        staticStyle: { padding: "16px !important" }
      },
      [_c("h3", [_vm._v("CSV出力")])]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }